// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@container invoice-report (min-width: 860px) {\n.invoice-report .report-chart-grid {\n    grid-template-columns: minmax(0, 1.6fr) minmax(280px, 1fr);\n}\n}\n@container invoice-report (max-width: 620px) {\n.invoice-report .metric-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n}", ""]);
// Exports
module.exports = exports;
